/* Copyright (c) 2020-present CloudIO Inc */

/* eslint-disable @typescript-eslint/no-explicit-any */

import { areEqualShallow } from '@cloudio-saas/statex';
import stringify from 'json-stable-stringify';

function memoizePreviousValue() {
  let jsonString: string;
  let previousValue: any;
  return <T>(value: T): T => {
    const json = stringify(value);
    if (jsonString !== json) {
      previousValue = value;
      jsonString = json;
    }
    return previousValue;
  };
}

function memoizeFunctionResults() {
  let oldDeps: any[];
  let val: any;
  return <T>(factory: () => T, deps: any[]): T => {
    if (!areEqualShallow(oldDeps, deps)) {
      val = factory();
      oldDeps = deps;
    }
    return val as T;
  };
}

function memoize() {
  const map = new Map<
    string | number,
    <T>(factory: () => T, deps: any[]) => T
  >();
  return {
    withKey: (key: string | number) => {
      let _memo = map.get(key);
      if (!_memo) {
        _memo = memoizeFunctionResults();
        map.set(key, _memo);
      }
      return _memo;
    },
    clear: () => {
      map.clear();
    },
  };
}

export { memoize, memoizeFunctionResults, memoizePreviousValue };
